import React from "react";
import "./Enterprise.scss";

const Enterprise = () => {
  return (
    <section className="enterprise">
      <div className="enterprise__container">
        <div className="enterprise__image-grid">
          <div className="enterprise__image-item enterprise__image-item--large">
            <img
              src="/enterprise/enterprise_chair.png"
              alt="Comfortable chair"
            />
          </div>
          <div className="enterprise__image-item">
            <img
              src="/enterprise/enterprise_interior.png"
              alt="Interior design"
            />
          </div>
          <div className="enterprise__image-item">
            <img src="/enterprise/enterprise_jar.png" alt="Product jar" />
          </div>
          <div className="enterprise__image-item">
            <img
              src="/enterprise/enterprise_greenhouse.png"
              alt="Wooden greenhouse"
            />
          </div>
        </div>
        <div className="enterprise__content">
          <h2 className="enterprise__label">Enterprise</h2>
          <h1 className="enterprise__heading">
            Save your team time and money, without skimping on features
          </h1>
          <p className="enterprise__description">
            Get full access to the ALL3D platform at the best price for your
            team with an enterprise account. Ideal for large retailers,
            manufacturers, interior design firms, and real estate agencies.
          </p>
          <div className="enterprise__cta">
            <button
              className="enterprise__button enterprise__button--primary"
              onClick={() =>
                window.open("https://all3d.ai/contact-us", "_blank")
              }
            >
              Request a Demo
            </button>
            <button
              className="enterprise__button enterprise__button--secondary"
              onClick={() =>
                window.open("https://all3d.ai/contact-us", "_blank")
              }
            >
              Contact Sales
            </button>
          </div>
          <p className="enterprise__trial">
            <span> Want to try the ALL3D platform first? </span>

            <a
              href="https://app.all3d.ai/register"
              className="enterprise__trial-link"
              target="_blank"
            >
              Start your free 14-day trial
            </a>
          </p>
        </div>
      </div>
    </section>
  );
};

export default Enterprise;
